/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';

// @ts-ignore
import {GetLocalizedText} from "./../../themes/kent/utilities/functions";
// @ts-ignore
import {GeneralAssetUrl} from "./../../themes/kent/utilities/constants";
// @ts-ignore
import ReactHtmlParser from 'react-html-parser';

interface IState {
  fullDescriptionToggled?:any;
}

interface IProps {
  product?: any;
  parentProduct?:any;
}

/**
 *
 * Description component
 * @extends {React.PureComponentReact.Component<IProps,IState>}
 */

class Description extends React.Component<IProps,IState> {
  public state: IState;

  constructor(props: IProps) {
      super(props);
      this.state = {};
  }
	toggleDescription = () =>{
		if(this.state.fullDescriptionToggled){
			this.setState({
				fullDescriptionToggled:false
			})
		} else{
			this.setState({
				fullDescriptionToggled:true
			})
		}
	}

  public render(): JSX.Element {
    var description = GetLocalizedText(this.props.product.attributes.content, "description");
    if(this.props.parentProduct){
      description = GetLocalizedText(this.props.parentProduct.attributes.content, "description");
    }
    let brand = this.props.product.attributes.brand;
		let longDescription;
		let shortDescription = description;
		if(description){
			if(description.length > 425){
				shortDescription = description.slice(0,425)+"...";
				longDescription = true;
			}
		}
		let fullDescription = description;
    return (
			<div>
			{description &&
				<div className="product-description secondary-font" style={{marginTop:"20px"}}>
					<p className="text-color-secondary" style={{whiteSpace:'break-spaces'}}>
            {(brand == "hosports" && description) && ReactHtmlParser(this.state.fullDescriptionToggled ? fullDescription : shortDescription)}
            {(brand == "hosports" && longDescription) && <div style={{cursor:"pointer"}} className="primary-color" onClick={this.toggleDescription}>{!this.state.fullDescriptionToggled ? 'Read More' : 'Read Less'}</div>}
            {(brand != "hosports" && description) && ReactHtmlParser(description)}
					</p>
				</div>
			}
			</div>
		)
  }
}

export default Description;
